import Vue from 'vue'
import VueRouter from 'vue-router'
import wap from '@/components/wap'
import index from '@/components/index'
import aboutUs from '@/components/aboutUs'
import businessIntroduction from '@/components/businessIntroduction'
import contactUS from '@/components/contactUS'
import product from '@/components/product'
import introductionPage from '@/components/product/brokenScreenInsurance/introductionPage'
import brokenScreenInsurance_infoFillingPage from '@/components/product/brokenScreenInsurance/infoFillingPage'
import familyPropertyInsurance_infoFillingPage from '@/components/product/familyPropertyInsurance/infoFillingPage'
import serviceAgreementPage from '@/components/product/serviceAgreementPage'
import sskIntroductionPage from '@/components/product/ssk/introductionPage'
import zfbIntroductionPage from '@/components/product/zfb/introductionPage'
import equipmentInsurance from '@/components/product/equipmentInsurance'
import CTAInsurance from '@/components/product/CTAInsurance'

Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

export default new VueRouter({
  // mode: 'hash',
  mode: 'history',
  routes: [
    {
      // 首页
      path: '/',
      name: 'wap',
      component: wap,
      children: [
        {
          path: '/',
          name: 'index',
          component: index,
          meta: {
            title: '米兔网络科技官网',
          },
        },
        {
          path: 'aboutUs',
          name: 'aboutUs',
          component: aboutUs,
          meta: {
            title: '关于我们',
          },
        },
        {
          path: 'businessIntroduction',
          name: 'businessIntroduction',
          component: businessIntroduction,
          meta: {
            title: '业务项目介绍',
          },
        },
        {
          path: 'contactUS',
          name: 'contactUS',
          component: contactUS,
          meta: {
            title: '联系我们',
          },
        },
        {
          // 工程机械设备&道路承运人保险
          path: 'equipmentInsurance',
          name: 'equipmentInsurance',
          component: equipmentInsurance,
          meta: {
            title: '工程机械设备&道路承运人保险',
          },
        },
        {
          // 综合交通意外险
          path: 'CTAInsurance',
          name: 'CTAInsurance',
          component: CTAInsurance,
          meta: {
            title: '综合交通意外险',
          },
        },
      ]
    },
    {
      path: '/product',
      name: 'product',
      component: product,
      children: [
        {
          // 介绍页
          path: 'brokenScreenInsurance/introductionPage',
          name: 'introductionPage',
          component: introductionPage,
          meta: {
            title: '权益领取',
          },
        },
        {
          // 碎屏险 - 信息填写页
          path: 'brokenScreenInsurance/infoFillingPage',
          name: 'brokenScreenInsurance_infoFillingPage',
          component: brokenScreenInsurance_infoFillingPage,
          meta: {
            title: '权益信息填写',
          },
        },
        {
          // 家财险 - 信息填写页
          path: 'familyPropertyInsurance/infoFillingPage',
          name: 'familyPropertyInsurance_infoFillingPage',
          component: familyPropertyInsurance_infoFillingPage,
          meta: {
            title: '权益信息填写',
          },
        },
        {
          // 服务协议页
          path: 'serviceAgreementPage',
          name: 'serviceAgreementPage',
          component: serviceAgreementPage,
          meta: {
            title: '米兔科技服务协议',
          },
        },
        {
          // 穗岁康 - 登录验证页
          path: 'sskIntroductionPage',
          name: 'sskIntroductionPage',
          component: sskIntroductionPage,
          meta: {
            title: '穗岁康',
          },
        },
        {
          // 肇福保 - 产品介绍页
          path: 'zfbIntroductionPage',
          name: 'zfbIntroductionPage',
          component: zfbIntroductionPage,
          meta: {
            title: '肇福保',
          },
        },
      ]
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
  /*scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  },*/
})



// WEBPACK FOOTER //
// ./src/router/index.js